module.exports = __webpack_public_path__ + "static/paradigms-of-artificial-intelligence-programming-c15ee02504ebc3683d8a92fb0a3836d8.jpg";